import { DatePipe } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  faChevronLeft,
  faFileExcel,
  faPrint,
  faRectangleList,
  faTrashCan,
} from '@fortawesome/free-solid-svg-icons';
import {
  ModalDismissReasons,
  NgbModal,
  NgbPopover,
  NgbPopoverConfig,
} from '@ng-bootstrap/ng-bootstrap';
import {
  CmsService,
  GlobalMessageService,
  GlobalMessageType,
  OccEndpointsService,
  RoutingService,
} from '@spartacus/core';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { enGbLocale } from 'ngx-bootstrap/locale';
import { filter, first, Subscription } from 'rxjs';
import { CustomProdPgService } from 'src/app/custom-prod-pg/custom-prod-pg.service';
import { DATA_LAYER_PROCESS_TYPES } from 'src/app/shared/modules/data-layer/constants/data-layer.constants';
import { ProductUtils } from 'src/app/shared/utils/productUtils';
import * as _ from 'underscore';
import { PLP_ALL_PRODUCTS } from '../../../shared/config/app.config';
import { CustomAddToCartService } from '../../custom-add-to-cart.service';
import { ProductDetailsComponent } from '../product-details/product-details.component';
import { DataLayerService } from '../../../shared/modules/data-layer/services/data-layer.service';
import { DATE_FORMAT } from 'src/app/shared';

@Component({
  selector: 'app-standard-cart',
  templateUrl: './standard-cart.component.html',
  styleUrls: ['./standard-cart.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class StandardCartComponent implements OnInit, OnDestroy {
  deliveryPickup: string = 'delivery';
  isSticky: boolean = false;
  public productInfo: {
    available: boolean;
    availabilityText: string;
    batchInfo: {
      batchNumber: string;
      expiryDate: string;
      quantity: number;
    };
    images: any;
    code: string;
    description: string;
    discontinued: boolean;
    sapAllocation: boolean;
    displayProduct: boolean;
    flu: boolean;
    nameHtml: any;
    summary: any;
    productUpdate: string;
    productDocuments: {
      productDocument: [
        {
          url: string;
        },
      ];
    };
    name: string;
    orderable: boolean;
    quantityPerUnit: number;
    productUpdates: string;
    productDocument: any;
    volumePrices: [
      {
        currencyIso: string;
        formattedValue: string;
        maxQuantity: string;
        minQuantity: string;
        priceType: string;
        value: string;
      },
    ];
    url: string;
    stock: {
      isValueRounded: boolean;
    };
    isValueRounded: boolean;
    yellowFever: boolean;
    volumePricesFlag: boolean;
  } = null;
  standardCartDetails: any;
  productEntries: any = [];

  updateTotal: boolean;
  updateEntriesData: any = [];
  subTotal: number;
  baseUrl: string;
  minDeliveryDate = new Date(new Date().setDate(new Date().getDate() + 1));
  maxDeliveryDate = new Date();
  minPickupDate = new Date();
  maxPickupDate = new Date();
  currentTime = new Date().getHours();
  pickupTimeFormat: any = [];
  timeFormat: any;
  selectedTime: any;
  deliveryDate: Date;
  deliveryCrossIcon: boolean;
  pickupDate: Date;
  deliveryDateFormat: string;
  pickupDateFormat: string;
  pickupCrossIcon: boolean;
  fallbackImage =
    '.../../../../../../assets/i18n-assets/sanofiwebb_missing_product.png';
  closeResult = '';
  usergetDataObj: any;
  getuserData: any;
  searchedClientList: any;
  selectedData: any;
  listSelectedData: any;
  userAccountgetData: any;
  saveCartName: string;
  popoverConfig: NgbPopoverConfig;
  cartId: any;
  errorMsg: string;
  deleteSuccess: string;
  addSuccess = false;
  cartItems: any;
  changeLocation = false;
  templatePage: any;
  prodAddedSub: Subscription;
  cartItemsSub: Subscription;
  removeEntriesSub = new Subscription();
  deleteCartSub: Subscription;
  cartDetailsSub: Subscription;
  checkoutDetailsSub: Subscription;
  checkoutFailedSub: Subscription;
  userAccountDetailsSub: Subscription;
  changedLocSub: Subscription;
  saveCartInvalidSub: Subscription;
  saveCartSuccessSub: Subscription;
  plpMiniCartSub: Subscription;
  userDataSub: Subscription;
  @ViewChild('p2') public savePopover: NgbPopover;
  orderBlock = false;
  showDangerAlert = false;
  checkoutClicked = false;
  yfEntry = false;
  // icons
  faPrint = faPrint;
  faFileExcel = faFileExcel;
  faTrashCan = faTrashCan;
  faRectangleList = faRectangleList;
  faChevronLeft = faChevronLeft;
  cartDetailsRan: boolean = false;
  plpAllProductsLink = PLP_ALL_PRODUCTS;
  DATE_FORMAT = DATE_FORMAT;

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly addToCart: CustomAddToCartService,
    readonly user: UserAccountFacade,
    private readonly modalService: NgbModal,
    public datepipe: DatePipe,
    private readonly config: NgbPopoverConfig,
    private readonly route: RoutingService,
    private readonly occEndPoint: OccEndpointsService,
    private readonly plpService: CustomProdPgService,
    protected globalMessage: GlobalMessageService,
    private readonly pageDate: CmsService,
    protected dataLayerService: DataLayerService
  ) {
    this.updateTotal = false;
    enGbLocale.weekdaysShort = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
    enGbLocale.week.dow = 0;
    this.pickupTimeFormat = [
      '09:00 am',
      '10:00 am',
      '11:00 am',
      '12:00 pm',
      '01:00 pm',
      '02:00 pm',
      '03:00 pm',
      '04:00 pm',
      '05:00 pm',
    ];
    this.selectedTime = null;
    config.autoClose = 'outside';
    this.deleteSuccess = '';
    this.addSuccess = false;
  }

  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    this.isSticky = window.scrollY >= 400;
  }

  ngOnInit(): void {
    this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);
    this.plpMiniCartSub = this.plpService
      .getUpdateMiniCart()
      .subscribe((res) => {
        if (res) {
          this.addToCart.removedEntries(res, this.userAccountgetData?.userName);
          this.removeEntriesMapping();
        }
      });
    this.plpService.stdCartMsg.next(false);
    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
    this.pageDate.getCurrentPage().subscribe((res) => {
      if (res) {
        this.templatePage = res?.template;
      }
    });
    this.userDataSub = this.user.get().subscribe((res) => {
      if (res && res != null) {
        this.userAccountgetData = res;
        this.getUserAccountData();
        // this.addToCart.allCartItems$.subscribe((res1) => {
        //   if (res1) {
        //     this.cartItems = res1?.carts;
        //     this.cartItems = this.cartItems[this.cartItems?.length - 1]
        //     this.cartId = this.cartItems?.code;
        //     if (this.cartItems === undefined) {
        this.productEntries = [];
        //}
        this.getCartDetails();
        this.cdr.detectChanges();
        // }
        //});
      }
    });
    this.prodAddedSub = this.plpService.stdCartMsg$.subscribe((res) => {
      if (res) {
        this.addSuccess = true;
        this.deleteSuccess = '';
        this.plpService.stdCartMsg.next(false);
      }
    });
    this.setDeliveryDate();
  }

  getCartDetails() {
    this.handleViewCartEvent();
    this.cartItemsSub = this.addToCart.cartItems$.subscribe((cartData: any) => {
      if (cartData) {
        this.cartDataMapping(cartData);
      }
    });
    if (this.cartId && this.templatePage === 'CartPageTemplate') {
      this.addToCart.removedEntries(
        this.cartId,
        this.userAccountgetData?.userName
      );
      this.removeEntriesMapping();
    }
  }

  handleViewCartEvent() {
    this.addToCart.cartItems$
      .pipe(first(Boolean))
      .subscribe((cartData: any) => {
        const currentStandardCart = cartData?.childCarts?.find(
          (item) => item.cartType === 'STANDARD'
        );

        this.dataLayerService.viewCart({
          ...currentStandardCart,
          childCartsNumber: 1,
          processType: DATA_LAYER_PROCESS_TYPES.STANDARD_PROCESS,
        });
      });
  }
  print() {
    window.print();
  }
  removeEntriesMapping() {
    this.removeEntriesSub.add(
      this.addToCart.removedItems$
        .pipe(filter(Boolean))
        .subscribe((res: any) => {
          const removedData = res?.removedEntries?.cartModifications;
          let stdCartDetails;
          this.yfEntry = false;
          stdCartDetails = res?.childCarts;
          stdCartDetails = stdCartDetails?.filter(
            (item) => item.cartType === 'STANDARD'
          );
          stdCartDetails = Object.assign({}, ...stdCartDetails);
          stdCartDetails?.entries?.forEach((entries) => {
            if (entries?.product?.yellowFever) {
              this.yfEntry = true;
            }
          });

          if (!stdCartDetails?.shipToParty?.yellowFeverFlag && this.yfEntry) {
            this.yfEntry = true;
          } else {
            this.yfEntry = false;
            this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);
          }
          if (removedData && removedData?.length > 0) {
            for (const data of removedData) {
              if (
                !stdCartDetails?.shipToParty?.yellowFeverFlag &&
                this.yfEntry
              ) {
                this.globalMessage.add(
                  data.statusMessage,
                  GlobalMessageType.MSG_TYPE_ERROR,
                  5000000
                );
              } else {
                this.globalMessage.add(
                  data.statusMessage,
                  GlobalMessageType.MSG_TYPE_ERROR
                );
              }
            }
          }
          this.addToCart.getAllCarts(this.userAccountgetData?.userName);
          this.addToCart.removedItems.next(false);
        })
    );
  }

  cartDataMapping(data): void {
    let stdCartDetails = [];
    this.productEntries = [];
    this.cartId = data?.code;
    stdCartDetails = data?.childCarts;
    if (stdCartDetails) {
      stdCartDetails = stdCartDetails.filter(
        (item) => item.cartType === 'STANDARD'
      );
      this.standardCartDetails = Object.assign({}, ...stdCartDetails);
      for (const cartDetails of stdCartDetails) {
        for (const entries of cartDetails.entries) {
          this.productEntries.push({ ...entries });
        }
      }
      if (this.standardCartDetails?.shipToParty) {
        this.selectedData =
          this.standardCartDetails?.shipToParty?.shippingAddresses.filter(
            (item) => item.unitID === this.standardCartDetails.shipToParty.uid
          );
        this.selectedData = _.first(this.selectedData);
      } else if (this.getuserData && this.getuserData?.length > 0) {
        this.selectedData = _.first(
          this.getuserData.filter(
            (item) => item.unitID === this.userAccountgetData?.uid
          )
        );
      }

      this.saveCartName = this.selectedData?.companyName?.slice(0, 30);

      this.cdr.detectChanges();
    }
  }

  performQuantityComputation(operator, idData, quantityOfUnits, entry): void {
    ProductUtils.alterQuantity(operator, idData, quantityOfUnits);
    this.updateTotal = true;
    const inputElement = document.getElementById(
      `prodQuantity${idData}`
    ) as HTMLInputElement;
    const params = { entryNumber: entry, quantity: inputElement.value };
    if (
      this.updateEntriesData.some(
        ({ entryNumber }) => entryNumber === params.entryNumber
      )
    ) {
      this.updateEntriesData[
        this.updateEntriesData.findIndex(
          (el) => el.entryNumber === params.entryNumber
        )
      ] = params;
    } else {
      this.updateEntriesData = [...this.updateEntriesData, params];
    }
  }

  deleteCart(entryNumber, prodName): void {
    this.addToCart.deleteCartItem(
      entryNumber,
      this.standardCartDetails.code,
      this.cartId
    );
    this.deleteCartSub = this.addToCart.deleteItems$.subscribe((res) => {
      if (res) {
        this.addToCart.deleteItems.next(false);
        this.addToCart.removedEntries(
          this.cartId,
          this.userAccountgetData?.userName
        );
        this.removeEntriesMapping();
        this.deleteSuccess = prodName;
        this.addSuccess = false;
      }
    });
  }

  closeAlert() {
    this.deleteSuccess = '';
    this.addSuccess = false;
  }

  closeDangerAlert() {
    this.showDangerAlert = false;
  }

  clearChildCart(): void {
    this.addToCart.clearCart(this.standardCartDetails.code);
  }

  openPopover(popover) {
    popover.open();
  }

  toggle(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
    this.errorMsg = '';
    this.saveCartName = this.selectedData?.companyName?.slice(0, 30);
  }

  updateCart(): void {
    this.addToCart.updateCartDetails(
      this.standardCartDetails.code,
      this.updateEntriesData,
      this.cartId
    );
    this.cartDetailsSub = this.addToCart.cartDetails$.subscribe((res: any) => {
      if (res) {
        this.updateTotal = false;
        let stdCartDetails = [];
        stdCartDetails = res?.childCarts;
        stdCartDetails = stdCartDetails.filter(
          (item) => item.cartType === 'STANDARD'
        );
        this.standardCartDetails = Object.assign({}, ...stdCartDetails);
        this.updateEntriesData = [];
      }
      this.cdr.detectChanges();
    });
  }

  productDetails(productDetails): void {
    const modalRef = this.modalService.open(ProductDetailsComponent, {
      windowClass: 'product-details-modal',
    });
    modalRef.componentInstance.productDetails = productDetails;
    modalRef.componentInstance.standardCartCode = this.standardCartDetails.code;
    modalRef.componentInstance.unitSection = 'Update';
  }

  productThumbnail(productDetails): string {
    const thumbnail = productDetails.product.images?.find(
      (i) => i.format === 'thumbnail'
    );
    if (thumbnail) {
      return this.baseUrl + thumbnail.url;
    }
    return this.fallbackImage;
  }

  onDeliveryDateChange(value: Date): void {
    if (value) {
      this.deliveryCrossIcon = true;
      this.deliveryDateFormat = this.datepipe.transform(value, 'yyyy-MM-dd');
    } else {
      this.deliveryCrossIcon = false;
    }
  }

  proceedToCheckout(): void {
    if (
      this.deliveryDateFormat ||
      (this.pickupDateFormat && this.selectedTime)
    ) {
      const params = {
        customerId: this.usergetDataObj.uid,
        date:
          this.deliveryPickup === 'delivery' &&
          (this.deliveryDateFormat || this.pickupDateFormat)
            ? this.deliveryDateFormat
            : this.pickupDateFormat,
        deliveryMode:
          this.deliveryPickup === 'delivery' ? 'standard' : 'pickup',
        pickupTime:
          this.deliveryPickup === 'pickup' && this.selectedTime
            ? this.selectedTime
            : '',
        shipToUnitId: this.selectedData?.unitID,
        standard: true,
      };
      this.addToCart.checkoutCart(params, this.cartId);
      this.checkoutClicked = true;
      this.checkoutDetailsSub = this.addToCart.checkoutDetails$.subscribe(
        (res) => {
          if (res) {
            this.checkoutClicked = false;
            this.route.goByUrl('/checkout');
          }
        }
      );
      this.checkoutFailedSub = this.addToCart.checkoutFailed$.subscribe(
        (res) => {
          if (res) {
            this.checkoutClicked = false;
          }
        }
      );
    }
  }

  open(content): void {
    this.searchedClientList = this.getuserData;
    this.modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  getUserAccountData(): void {
    this.userAccountDetailsSub = this.addToCart.userAccountDetails$.subscribe(
      (userDataget) => {
        if (userDataget) {
          this.usergetDataObj = userDataget.res;
          this.getuserData = userDataget.res.shippingAddresses;
          this.searchedClientList = userDataget.res.shippingAddresses;
          this.orderBlock = !!userDataget?.res?.orderBlockFlag;
          if (this.orderBlock) {
            this.showDangerAlert = true;
          }
          this.changeLocation = this.getuserData?.length <= 1;
          this.cdr.detectChanges();
        }
      }
    );
  }

  onOptionsSelected(data) {
    this.listSelectedData = data;
  }

  onSubmit(): void {
    if (this.listSelectedData) {
      this.selectedData = this.listSelectedData;
      this.addToCart.saveLocation(
        this.selectedData?.unitID,
        this.cartId,
        this.userAccountgetData?.userName
      );
      this.changedLocSub = this.addToCart.changedLocation$.subscribe((res) => {
        if (res) {
          this.addToCart.removedEntries(
            this.cartId,
            this.userAccountgetData?.userName
          );
          this.removeEntriesMapping();
        }
      });
    }
  }

  searchClientName(data: any) {
    if (data.length > 0) {
      const fieldsToCheck = [
        'companyName',
        'unitID',
        'line1',
        'line2',
        'town',
        'postalCode',
      ];
      this.searchedClientList = this.getuserData.filter(
        (x) =>
          fieldsToCheck.some((field) =>
            x[field]?.toLowerCase().includes(data.toLowerCase())
          ) ||
          x.region?.isocodeShort?.toLowerCase().includes(data.toLowerCase())
      );
    } else {
      this.searchedClientList = this.getuserData;
    }
  }

  saveOrder(): void {
    const reg = /^[^`!@#~$%\\^&*()_+\-={};':"\\|[\]\\.,<>/\\/?~]*$/;
    if (this.saveCartName && RegExp(reg).test(this.saveCartName)) {
      this.addToCart.saveCartDetails(this.saveCartName, this.cartId);
      this.saveCartInvalidSub = this.addToCart.invalidCartName$.subscribe(
        (res) => {
          if (res) {
            for (const error of res.error.errors) {
              this.errorMsg = error?.message;
            }
          }
        }
      );
      this.saveCartSuccessSub = this.addToCart.saveCartSuccess$.subscribe(
        (res) => {
          if (res) {
            if (this.savePopover) {
              this.savePopover.close();
            }
            this.errorMsg = '';
            this.saveCartName = this.selectedData?.companyName?.slice(0, 30);
          }
        }
      );
    } else if (this.saveCartName) {
      this.errorMsg =
        'Der eingegebene Name ist ungültig. Sonderzeichen sind nicht erlaubt, bitte versuchen Sie es erneut.';
    } else {
      this.errorMsg = 'Der Warenkorbname darf nicht leer sein';
    }
  }

  exportXls() {
    const cartProducts = [];
    for (const entries of this.productEntries) {
      cartProducts.push({
        'Product Name': entries?.product?.name,
        'Product Num': entries?.product?.code,
        Quantity: entries?.quantity,
      });
    }
    this.addToCart.downloadXls(cartProducts, 'Cart');
  }

  omitSpecialChar(event) {
    this.errorMsg = '';
    const reg = /^[^`!@#~$%\\^&*()_+\-={};':"\\|[\]\\.,<>/\\/?~]*$/;
    return new RegExp(reg).test(event.key);
  }

  setDeliveryDate() {
    while (
      this.minDeliveryDate.getDay() >= 6 ||
      this.minDeliveryDate.getDay() === 0
    ) {
      this.minDeliveryDate.setDate(1);
    }

    this.maxDeliveryDate = new Date(this.minDeliveryDate);
    this.maxDeliveryDate.setDate(15);

    this.deliveryDate = this.minDeliveryDate;

    this.onDeliveryDateChange(this.deliveryDate);
  }

  ngOnDestroy() {
    this.prodAddedSub?.unsubscribe();
    this.cartItemsSub?.unsubscribe();
    this.removeEntriesSub?.unsubscribe();
    this.deleteCartSub?.unsubscribe();
    this.cartDetailsSub?.unsubscribe();
    this.checkoutDetailsSub?.unsubscribe();
    this.checkoutFailedSub?.unsubscribe();
    this.userAccountDetailsSub?.unsubscribe();
    this.changedLocSub?.unsubscribe();
    this.saveCartInvalidSub?.unsubscribe();
    this.saveCartSuccessSub?.unsubscribe();
    this.plpMiniCartSub?.unsubscribe();
    this.userDataSub?.unsubscribe();
    this.globalMessage.remove(GlobalMessageType.MSG_TYPE_ERROR);
  }
}
